"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReasonCode = exports.ReasonType = void 0;
var ReasonType;
(function (ReasonType) {
    ReasonType["CANCEL"] = "cancel";
    ReasonType["REFUSE"] = "refuse";
    ReasonType["CANCEL_ADMIN"] = "cancel_admin";
    ReasonType["CANCEL_CUSTOMER"] = "cancel_customer";
    ReasonType["CANCEL_ORDER_ADMIN"] = "cancel_order_admin";
})(ReasonType = exports.ReasonType || (exports.ReasonType = {}));
var ReasonCode;
(function (ReasonCode) {
    ReasonCode["ALREADY_HAS_A_CONTRACT"] = "already_has_a_contract";
    ReasonCode["APPOINTMENT_NOT_SUITABLE"] = "appointment_not_suitable";
    ReasonCode["CUSTOMER_DOES_NOT_ANSWER"] = "customer_does_not_answer";
    ReasonCode["DIY"] = "diy";
    ReasonCode["EMERGENCY"] = "emergency";
    ReasonCode["DONT_RELATE_DEPANNAGE"] = "dont_relate_depannage";
    ReasonCode["MISDIAGNOSIS"] = "misdiagnosis";
    ReasonCode["NOT_AVAILABLE"] = "not_available";
    ReasonCode["NO_EQUIPMENT"] = "no_equipment";
    ReasonCode["NO_MORE_ISSUE"] = "no_more_issue";
    ReasonCode["NO_PRODUCTS_MATCH"] = "no_products_match";
    ReasonCode["NO_SHOW"] = "no_show";
    ReasonCode["NO_SKILL"] = "no_skill";
    ReasonCode["OTHER"] = "other";
    ReasonCode["OTHER_WITH_FEES"] = "other_with_fees";
    ReasonCode["OTHER_WITHOUT_FEES"] = "other_without_fees";
    ReasonCode["TOO_EXPENSIVE"] = "too_expensive";
    ReasonCode["TOO_FAR"] = "too_far";
})(ReasonCode = exports.ReasonCode || (exports.ReasonCode = {}));
//# sourceMappingURL=reason.js.map